const Dashboard = () => import("./dashboard/view/Dashboard.vue");
import ExemptionRoutes from "./exemption/routes";
import LeaveRoutes from "./leave/routes";
import AppraisalRoutes from "./appraisal/routes";
import ReportRoutes from "./reports/routes";

export default [
  {
    path: "dashboard",
    component: Dashboard,
  },
  {
    path: "exemption",
    redirect: "/admin/hrm/exemption/all-exemptions",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: ExemptionRoutes,
  },
  {
    path: "leave",
    redirect: "/admin/hrm/leave/all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: LeaveRoutes,
  },
  {
    path: "appraisal",
    redirect: "/admin/hrm/appraisal/all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: AppraisalRoutes,
  },
  {
    path: "reports",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/admin/hrm/reports/generate",
    children: ReportRoutes,
  },
];
